import { Observable } from 'rxjs';

export interface IActionButton {
  icon?: string;
  name: string;
  run: () => Promise<void> | void;
  isDisabled$: Observable<boolean>;
  disabledMessage$: Observable<string>;
}
